import { render } from "./Armstrong.vue?vue&type=template&id=2c0a6349&scoped=true"
import script from "./Armstrong.vue?vue&type=script&lang=js"
export * from "./Armstrong.vue?vue&type=script&lang=js"

import "./Armstrong.vue?vue&type=style&index=0&id=2c0a6349&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c0a6349"]])

export default __exports__